import React, { useEffect, useState } from 'react'
import { Form as FinalForm, FormSpy } from 'react-final-form'
import noop from 'lodash/noop'
import { AvailabilityPayload, FieldProps } from './types'
import { GuestFormsCFAModel } from './models'

type Props = AvailabilityPayload & {
  children: (fields: FieldProps[], invalid: boolean) => React.ReactNode
  onChange: (values: any) => void
}

type InitialValues = {
  [key: string]: FieldProps
}

export const GuestFormsCFA = ({
  form,
  contactFields,
  leadFields,
  prospect,
  locale,
  children,
  onChange,
  isHubspot,
  isHotWorkspace,
}: Props) => {
  const [parsedFields, setParsedFields] = useState<FieldProps[]>([])
  const [initialValues, setInitialValues] = useState<InitialValues>({})
  const validation = GuestFormsCFAModel.createValidationSchema({ form, locale })
  useEffect(() => {
    setParsedFields(fields => {
      const newFields = GuestFormsCFAModel.createFields({
        form,
        contactFields,
        leadFields,
        locale,
        prospect,
        isHubspot,
        isHotWorkspace,
      })
      return newFields.length !== fields.length ? newFields : fields
    })
  }, [form, contactFields, leadFields, locale, prospect, isHubspot, isHotWorkspace])

  useEffect(() => {
    setInitialValues(
      parsedFields.reduce(
        (acc, f) => ({
          ...acc,
          [f.name]: f.initialValue,
        }),
        {}
      )
    )
  }, [parsedFields])

  const handleChanges = ({ values, invalid }: { invalid: boolean; values: any }) => {
    if (!invalid) {
      onChange(trimValues(values))
    }
  }

  return (
    <FinalForm
      onSubmit={noop}
      validate={validation}
      initialValues={initialValues}
      render={({ invalid }) => {
        return (
          <>
            <FormSpy subscription={{ values: true, invalid: true }} onChange={handleChanges} />
            {children(parsedFields, invalid)}
          </>
        )
      }}
    />
  )
}

const trimValues = (values: Record<string, string | number>) => {
  return Object.keys(values).reduce((fields, key) => {
    const value = values[key]
    if (typeof value === 'string') {
      return {
        ...fields,
        [key]: value.trim(),
      }
    }
    return {
      ...fields,
      [key]: value,
    }
  }, {})
}
